import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ITruckBrand } from '../../../shared/interfaces/ITruck';

interface IProps {
  register: UseFormRegister<ITruckBrand>;
  errors: FieldErrors<ITruckBrand>;
}
const TruckBrandForm = ({ register, errors }: IProps) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col md={12}>
        <Form.Group className="mb-3" controlId="form.name">
          <Form.Label>{t('general.name')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.name')}
            isInvalid={!!errors.name}
            {...register('name')}
          />
          {errors?.name && (
            <Form.Control.Feedback type="invalid">
              {errors.name.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group className="mb-3" controlId="form.firstServiceKm">
          <Form.Label>{t('general.firstServiceKm')}</Form.Label>
          <Form.Control
            type="number"
            placeholder={t('general.firstServiceKm')}
            isInvalid={!!errors.firstServiceKm}
            {...register('firstServiceKm')}
          />
          {errors?.firstServiceKm && (
            <Form.Control.Feedback type="invalid">
              {errors.firstServiceKm.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group className="mb-3" controlId="form.minorServiceIntervalKm">
          <Form.Label>{t('general.minorServiceIntervalKm')}</Form.Label>
          <Form.Control
            type="number"
            placeholder={t('general.minorServiceIntervalKm')}
            isInvalid={!!errors.minorServiceIntervalKm}
            {...register('minorServiceIntervalKm')}
          />
          {errors?.minorServiceIntervalKm && (
            <Form.Control.Feedback type="invalid">
              {errors.minorServiceIntervalKm.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group className="mb-3" controlId="form.majorServiceIntervalKm">
          <Form.Label>{t('general.majorServiceIntervalKm')}</Form.Label>
          <Form.Control
            type="number"
            placeholder={t('general.majorServiceIntervalKm')}
            isInvalid={!!errors.majorServiceIntervalKm}
            {...register('majorServiceIntervalKm')}
          />
          {errors?.majorServiceIntervalKm && (
            <Form.Control.Feedback type="invalid">
              {errors.majorServiceIntervalKm.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
    </Row>
  );
};

export default TruckBrandForm;
